var map = {
	"./AT.svg": 935,
	"./BP.svg": 936,
	"./BT_BP.svg": 522,
	"./BT_WS.svg": 523,
	"./CO2.svg": 937,
	"./GL.svg": 938,
	"./HR.svg": 939,
	"./PO.svg": 940,
	"./TM.svg": 941,
	"./WS.svg": 942,
	"./ZOE.svg": 943
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97;